import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  ReferenceInput,
  AutocompleteInput,
  FormDataConsumer,
  required,
  Identifier,
  RaRecord,
} from "react-admin";
import { parse } from "query-string";
import { useLocation } from "react-router";

import EmailInput from "../common/EmailInput";
import { validateFromEmailAddress, validateToEmailAddress } from "./validators";
import useCreateWithValidation from "../common/useCreateWithValidation";
import FormContainer from "../common/FormContainer";

export const helpNotes = (
  <>
    <p>
      Im Feld <b>Ziel E-Mail(s)</b> können mehrere Adressen hinterlegt werden -
      eine Adresse pro Zeile oder mehrere durch ein <b>,</b> getrennt.
    </p>
    <p>
      Wenn die Adresse im Feld <b>Von E-Mail</b> auch zu einem E-Mail Konto
      gehört, kann man diese Adresse zusätzlich im Feld <b>Ziel E-Mail(s)</b>{" "}
      angeben um eine Kopie der Mail im Postfach zu behalten.
    </p>
  </>
);

const MailForwardCreate = () => {
  const location = useLocation();
  // Read the post_id from the location which is injected by React Router and passed to our component by react-admin automatically
  const { customerId, domainId, returnTo } = parse(location.search);
  const fromDomain = (
    _resource?: string,
    _id?: Identifier,
    data?: Partial<RaRecord>,
    _state?: object
  ) => `Domain/${data?.domainId}/show/mail-forwards`;

  const save = useCreateWithValidation("MailForward", {
    redirectTo: returnTo === "MailForwardFromDomains" ? fromDomain : "list",
  });

  return (
    <Create>
      <SimpleForm defaultValues={{ customerId, domainId }} onSubmit={save}>
        <FormContainer>
          <ReferenceInput
            source="customerId"
            reference="Customer"
            sort={{ field: "name", order: "ASC" }}
            filterToQuery={(searchText: any) => ({
              q: searchText,
            })}
          >
            <AutocompleteInput
              optionText="name"
              fullWidth
              validate={required()}
            />
          </ReferenceInput>

          <FormDataConsumer>
            {({ formData, ...rest }) => (
              <ReferenceInput
                source="domainId"
                reference="Domain"
                sort={{ field: "unicodeName", order: "ASC" }}
                filter={{ customerId: formData.customerId }}
                filterToQuery={(searchText: any) => ({
                  q: searchText,
                })}
                {...rest}
              >
                <AutocompleteInput
                  optionText="unicodeName"
                  fullWidth
                  validate={required()}
                />
              </ReferenceInput>
            )}
          </FormDataConsumer>
          <EmailInput
            source="fromEmailAddress"
            validate={validateFromEmailAddress}
            allowEmptyLocalPart
            fullWidth
          />
          <TextInput
            multiline
            source="toEmailAddress"
            validate={validateToEmailAddress}
            fullWidth
          />
        </FormContainer>
        <FormContainer maxWidth="lg">
          <TextInput multiline source="description" fullWidth />
          {helpNotes}
        </FormContainer>
      </SimpleForm>
    </Create>
  );
};
export default MailForwardCreate;
